const accountModal = document.getElementById('account-modal');
const accountModalContent = document.getElementById('account-modal-content');

const recoverPWModal = document.querySelector('.recover-password-modal');
const loginModal = document.querySelector('.login-modal');
const registerModal = document.querySelector('.register-modal');

function openAccountModal() {
  accountModal.classList.add('animate', 'active');
  accountModalContent.classList.add('animate', 'active');
  document.body.classList.add('overflow-hidden');
  this.setActiveElement(accountModal);
}

function closeAccountModal() {
  accountModalContent.classList.add('closing');
  setTimeout(() => {
    accountModal.classList.remove('active');
    accountModalContent.classList.remove('active');
    accountModalContent.classList.remove('closing');
    this.closeRecoverPWModal();
    this.closeRegisterModal();
  }, 100);
  document.body.classList.remove('overflow-hidden');
  removeTrapFocus(this.activeElement);
}

function openRecoverPWModal() {
  recoverPWModal.classList.remove('hidden');
  loginModal.classList.add('hidden');
}

function closeRecoverPWModal() {
  recoverPWModal.classList.add('hidden');
  loginModal.classList.remove('hidden');
}

function openRegisterModal() {
  registerModal.classList.remove('hidden');
  loginModal.classList.add('hidden');
}

function closeRegisterModal() {
  registerModal.classList.add('hidden');
  loginModal.classList.remove('hidden');
}

function setActiveElement(element) {
  this.activeElement = element;
}

this.addEventListener('keyup', (event) => {
  if (event.key === 'Escape') this.closeAccountModal();
});

document.addEventListener('hiko', (event) => {
  console.log(event.detail);
  if (event.detail.customer_id) this.closeAccountModal();
});
